﻿import { opaccAjaxPlugin } from "./vendor/script/opacc.static.js";

export class AdditionsSummaryInfos {
    constructor() {
        this.inputSelector = '[data-additional-infos-to-save]';
        this.lastValue = null;
        this.lastEventElement = null;
        this.attachEventListener();
    }

    attachEventListener() {
        // get input fields
        const inputFields = document.querySelectorAll(this.inputSelector);


        inputFields.forEach((inputField) => {

            inputField.addEventListener("change", (e) => {

                const currentType = e.target.type;

                // get field content
                let currentData = currentType != "checkbox" ? inputField.value : inputField.checked;

                if(currentType === "checkbox") {
                    currentData = currentData ? 1 : 0;
                }

                // get filed url
                const fieldUrl = inputField.dataset.url;

                // save data
                let dataToPass = {
                    value: currentData
                };

                // only execute request if new data is available
                if(!((this.lastValue === currentData) && (e.target === this.lastEventElement))){
                    // store last event data
                    this.lastValue = currentData;
                    this.lastEventElement = e.target;

                    opaccAjaxPlugin.fetchAsynPostForm(fieldUrl,dataToPass ,(result) => {
                        // result contains info about free item -> log?
                    });

                }

            });


        });

    }

}

